module.exports = __webpack_public_path__ + "static/media/Bulb.a894e483.svg";